import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

export const experienceListState = {
   name: 'campaign.experiences',
   url: '/experiences',
   templateUrl: require('./experience-list.html'),
   controller: 'ExperienceListController as ctrl'
};

export const experienceEditState = {
   name: 'campaign.experienceEdit',
   url: '/experiences/:slug/{id:int}',
   params: { id: null },
   templateUrl: require('./experience-editor.html'),
   controller: 'ExperienceEditorController as ctrl',
   resolve: {
      experience: getExperience,
      campaign: getCampaign
   }
};

getExperience.$inject = ['$q', '$stateParams', 'experiencesService'];
function getExperience ($q:ng.IQService, $stateParams:uir.StateParams, experiencesService) {
   if ($stateParams.id) {
      return experiencesService.get($stateParams.id).catch(err => {
         if (err.status == 404) {
            let message = 'The experience you were looking for could not be found.';
            return $q.reject({message: message});
         } else {
            return $q.reject(err);
         }
      });
   }

   return null;
}

getCampaign.$inject = ['campaignsApi', 'session'];
function getCampaign (campaignsApi, session) {
   return campaignsApi.get(session.getCampaign().id);
}

ng.module('e360').config(configRoutes);

configRoutes.$inject = ['$stateRegistryProvider'];
function configRoutes($stateRegistry:uir.StateRegistry) {
   $stateRegistry.register(experienceListState);
   $stateRegistry.register(experienceEditState);
}
